function isObject(value) {
  return value !== null && typeof value === "object";
}

function isPlainObject(value) {
  if (!isObject(value)) return false;
  const proto = Object.getPrototypeOf(value);
  return proto === Object.prototype || proto === null;
}

function isClassInstance(value) {
  if (!isObject(value)) return false;
  if (Array.isArray(value)) return false;
  const proto = Object.getPrototypeOf(value);
  // Has a custom prototype = class instance (Date, Map, RegExp, your classes, etc.)
  return proto !== Object.prototype && proto !== null;
}

function mergeDeep(target, sources, seen) {
  const sourceSize = sources.length;
  for (let sourceIndex = 0; sourceIndex < sourceSize; sourceIndex++) {
    const source = sources[sourceIndex];
    if (!isObject(source)) continue;

    if (isPlainObject(source)) {
      if (seen.has(source)) continue;
      seen.set(source, true);
    }

    const sourceKeys = Object.keys(source);
    const sourceKeysSize = sourceKeys.length;
    for (let keyIndex = 0; keyIndex < sourceKeysSize; keyIndex++) {
      const key = sourceKeys[keyIndex];
      const srcVal = source[key];
      const tgtVal = target[key];

      if (srcVal === undefined) {
        // Skip undefined
        continue;
      } else if (isClassInstance(srcVal)) {
        // Class instances: assign by reference, never recurse into them
        target[key] = srcVal;
      } else if (Array.isArray(srcVal)) {
        // Clone any existing target array to avoid mutating the original target
        const base = Array.isArray(tgtVal) ? [...tgtVal] : [];
        target[key] = base;
        mergeDeep(base, [srcVal], seen);
      } else if (isPlainObject(srcVal)) {
        // Clone any existing target plain object to avoid mutating the original target
        const base = isPlainObject(tgtVal) ? { ...tgtVal } : {};
        target[key] = base;
        mergeDeep(base, [srcVal], seen);
      } else {
        // Primitives (string, number, boolean, null, Symbol, etc.)
        target[key] = srcVal;
      }
    }
  }

  return target;
}

export function merge(target, ...sources) {
  const seen = new WeakMap();
  // Shallow clone target so the original object is never mutated
  const result = isPlainObject(target) ? { ...target } : {};
  return mergeDeep(result, sources, seen);
}
